import ShelfApi from "./ShelfApi"

export default class BlobDownload {
  constructor(
    endpoint,
    filename,
    options = {mimeType: "text/csv", headers: {}}
  ) {
    this.endpoint = endpoint
    this.filename = filename
    this.mimeType = options.mimeType
    this.headers = options.headers

    this._loading = false
    this._loaded = false
    this._pseudoLink = null
    this._localUrl = null
  }

  isLoaded() {
    return this._loaded
  }

  /**
   * Start downloading the file.
   */
  // inspired by
  // https://gist.github.com/Tomassito/a5b4d29f459b9383dc3daa313ae5f73b
  loadFile() {
    if (this._loading || this._loaded) return null

    this._loading = true

    return ShelfApi({
      url: this.endpoint,
      method: "GET",
      // this makes it a file download
      responseType: "blob",
      headers: {...ShelfApi.headers, ...this.headers}
    })
      .then(response => {
        const blob = new Blob([response.data], {type: this.mimeType})

        const pseudoLink = document.createElement("a")
        document.body.appendChild(pseudoLink)
        const localUrl = window.URL.createObjectURL(blob)

        pseudoLink.href = localUrl
        pseudoLink.setAttribute("download", this.filename)
        pseudoLink.setAttribute("target", "_blank")
        pseudoLink.click()

        this._loading = false
        this._loaded = true
        this._pseudoLink = pseudoLink
        this._localUrl = localUrl
      })
      .catch(error => {
        this._loading = false
        this._loaded = false

        throw error
      })
  }

  /**
   * get the file as a download pop-up (if it is fully downloaded)
   */
  getFile() {
    if (this._loading || !this._loaded) return
    else this._pseudoLink.click()
  }

  /**
   * free up used memory and url resources
   */
  freeResources() {
    window.URL.revokeObjectURL(this._localUrl)
    document.body.removeChild(this._pseudoLink)
  }
}



// WEBPACK FOOTER //
// ./src/utils/BlobDownload.js